import React from 'react'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { isEmpty } from 'lodash'
import { Notification } from 'src/components/Notification'

export const handleErrorMessage = (error: AxiosError, action: string, entity: string) => {
  if (error?.response?.status === 500) {
    toast.error(() => (
      <Notification message={`Error ${action}ting ${entity}: An unknown error has ocurred`} />
    ))
  } else if (error?.response?.data && !isEmpty(error.response.data)) {
    if (error.response.data.details) {
      toast.error(() => (
        <Notification message={`Error ${action}ing Order: ${error?.response?.data.details}`} />
      ))
    } else if (error.response.data.non_field_errors) {
      toast.error(() => (
        <Notification
          message={`Error ${action}ing Order: ${error?.response?.data.non_field_errors}`}
        />
      ))
    } else {
      toast.error(() => (
        <Notification message={`Error ${action}ing ${entity}: See inline errors above.`} />
      ))
    }
  } else {
    toast.error(() => (
      <Notification message={`Error ${action}ting ${entity}: An unknown error has ocurred`} />
    ))
  }
}
